import React from "react";
import logo from "assets/images/logo-brand.png";

/**
 * FassetLoader — branded loading indicator used app-wide.
 * Replaces the old broken SVG spinner with:
 *   • Fasset logo (green-tinted)
 *   • Smooth indeterminate progress bar
 *   • Subtle pulsing glow
 */
const CircularProgress = ({ className }) => (
  <div
    className={`loader ${className || ""}`}
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "48px 24px",
      minHeight: 220,
    }}
  >
    {/* ── Logo ── */}
    <div
      style={{
        marginBottom: 28,
        animation: "fasset-pulse 2.2s ease-in-out infinite",
      }}
    >
      <img
        src={logo}
        alt="Fasset"
        style={{
          height: 30,
          width: "auto",
          objectFit: "contain",
          display: "block",
        }}
      />
    </div>

    {/* ── Progress bar track ── */}
    <div
      style={{
        width: 180,
        height: 3,
        background: "rgba(74,183,89,0.15)",
        borderRadius: 99,
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* animated fill */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          background: "linear-gradient(90deg, transparent, #3daa4e, #2e8440, transparent)",
          borderRadius: 99,
          animation: "fasset-bar 1.6s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        }}
      />
    </div>

    {/* ── "Loading…" label ── */}
    <span
      style={{
        marginTop: 16,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        color: "rgba(74,183,89,0.55)",
        animation: "fasset-fade 1.6s ease-in-out infinite",
      }}
    >
      Loading
    </span>

    {/* ── Keyframes injected once ── */}
    <style>{`
      @keyframes fasset-bar {
        0%   { width: 0%;   left: 0%;   }
        40%  { width: 65%;  left: 10%;  }
        80%  { width: 20%;  left: 80%;  }
        100% { width: 0%;   left: 100%; }
      }
      @keyframes fasset-pulse {
        0%, 100% { opacity: 1;    transform: scale(1);    }
        50%       { opacity: 0.7; transform: scale(0.97); }
      }
      @keyframes fasset-fade {
        0%, 100% { opacity: 0.5; }
        50%       { opacity: 1;  }
      }
    `}</style>
  </div>
);

export default CircularProgress;
